module.exports = __webpack_public_path__ + "4e0cd58ca8277d6809e0df8591eded85.png";